import { cn } from "@/lib/utils";
import { Column } from "./flex";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("bg-primary/10 animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export function TableSkeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Column className={cn("gap-1", className)} {...props}>
      <Skeleton className="mb-2 h-[20px] w-1/4" />
      {Array(3)
        .fill(0)
        .map((_, idx) => (
          <Skeleton key={idx} className="h-[36px] w-full" />
        ))}
    </Column>
  );
}
